import { useState } from 'react';
import { MAX_NAME_LENGTH } from '@ofc/shared';

/**
 * Shown when someone opens a room link without a name yet.
 *
 * A name is required rather than defaulted, because the host has to reorder the
 * circle and tell people when it is their turn — a room of "Player" is unusable.
 */
export function NamePrompt({
  roomCode,
  gameTitle,
  onName,
  onCancel,
}: {
  roomCode: string;
  /** Which game the link is for. A friend tapping it should know what they are walking into. */
  gameTitle?: string;
  onName(name: string): void;
  onCancel(): void;
}) {
  const [name, setName] = useState('');
  const trimmed = name.trim();

  return (
    <main className="screen">
      <div style={{ flex: 1, display: 'grid', gridTemplateColumns: 'minmax(0, 1fr)', placeItems: 'center' }}>
        <div className="col" style={{ width: '100%', maxWidth: 380 }}>
          <header className="center">
            <div className="sign small muted" style={{ letterSpacing: '0.2em' }}>
              {gameTitle ? `Joining ${gameTitle}` : 'Joining room'}
            </div>
            <div
              className="sign neon neon-cyan"
              style={{ fontSize: 'clamp(36px, 15vw, 56px)', letterSpacing: '0.16em' }}
            >
              {roomCode}
            </div>
          </header>

          <div className="panel marquee col" style={{ padding: '22px 16px' }}>
            <label className="col" style={{ gap: 6 }}>
              <span className="sign small muted">What should we call you?</span>
              <input
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="Your name"
                maxLength={MAX_NAME_LENGTH}
                autoComplete="nickname"
                autoCapitalize="words"
                enterKeyHint="go"
                autoFocus
                onKeyDown={(e) => e.key === 'Enter' && trimmed && onName(trimmed)}
              />
            </label>

            <button className="btn-primary" disabled={!trimmed} onClick={() => onName(trimmed)}>
              {trimmed ? 'Join the game' : 'Enter a name'}
            </button>
          </div>

          <button className="btn-ghost small" onClick={onCancel}>
            Back
          </button>
        </div>
      </div>
    </main>
  );
}
